export function menuScroll() {
        var scroll_start = 0;
        var change_color = $('.main-header');
        var offset = change_color.offset();
      
        if (change_color.length){
            $(document).scroll(function() {
                console.log("菜单切换")
                scroll_start = $(this).scrollTop();
                if(scroll_start > offset.top) {
                    $(".main-header").removeClass("menu_trans");
                } else {
                    $(".main-header").addClass("menu_trans");
                }
                
            });
        }
  }

